// Modify Refund policy text to Returns & Exchanges
document.addEventListener('DOMContentLoaded', function() {
  const policyTitle = document.querySelector('.shopify-policy__title h1');
  
  if (policyTitle && policyTitle.textContent.includes('Refund policy')) {
    policyTitle.textContent = 'Returns & Exchanges';
    document.title = document.title.replace('Refund policy', 'Returns & Exchanges');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const mediaInfoContainer = document.querySelector('.js-product-media-info');
  document.querySelector(`#${mediaInfoContainer.dataset.formId}`).addEventListener('variant:change', (e) => {
    const selectedVariantId = e.target.querySelector('[name="id"]').value;
    
    // Toggle the visibility of the variant media
    document.querySelectorAll('.show-variant-media').forEach((element) => {
      if (element.dataset.variantId === selectedVariantId) {
        element.classList.remove('hidden');
      } else {
        element.classList.add('hidden');
      }
    });
  });
});